import React from "react";
import { Typography, Box } from "@material-ui/core";

function ADAContactText() {
  return (
    <>
      <Box style={{ margin: "24px 0 24px 0" }}>
        <Typography>
          University of Phoenix is required to prohibit discrimination and to provide reasonable accommodations and modifications to qualified students in all University programs and activities under the law.
        </Typography>
      </Box>

      <Box style={{ margin: "24px 0 24px 0" }}>
        <Typography>
          As faculty of University of Phoenix, you are responsible for implementing the approved accommodations for students in class. Accommodations are determined after a deliberative and interactive process between the student and University staff. Accommodations must be provided as indicated, following all guidelines and directives provided in the accommodation notification.
        </Typography>
      </Box>
    </>
  );
}

export default ADAContactText;
